// Merkan · Iconset (DS-04). ERZEUGT mit scripts/icons-erzeugen.mjs aus src/assets/marke/merkan-icons.json, nicht von Hand ändern.
// 24er Raster, Strich 1,75, runde Enden, Farbe über currentColor.
import type { SVGProps } from 'react';

export type IconProps = Omit<SVGProps<SVGSVGElement>, 'children'> & { size?: number | string };

function huelle(name: string, { size = 24, className, ...rest }: IconProps) {
  return {
    xmlns: 'http://www.w3.org/2000/svg', width: size, height: size, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor',
    strokeWidth: 1.75, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const, 'aria-hidden': true, focusable: false,
    className: `mi mi-${name}${className ? ` ${className}` : ''}`, ...rest,
  };
}

/** Dashboard (Navigation), animiert beim Überfahren */
export function IcDashboard(p: IconProps) {
  return <svg {...huelle('dashboard', p)}><rect className="t t1" x="3" y="3" width="7" height="9" rx="1.5"/><rect className="t t2" x="14" y="3" width="7" height="5" rx="1.5"/><rect className="t t3" x="14" y="12" width="7" height="9" rx="1.5"/><rect className="t t4" x="3" y="16" width="7" height="5" rx="1.5"/></svg>;
}

/** Kunden (Navigation), animiert beim Überfahren */
export function IcKunden(p: IconProps) {
  return <svg {...huelle('kunden', p)}><circle className="kopf kopf1" cx="9" cy="8" r="3.5"/><path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6"/><path className="kopf kopf2" d="M16 4.6a3.5 3.5 0 0 1 0 6.8"/><path d="M18 14.3c2 .7 3.5 2.6 3.5 5.2"/></svg>;
}

/** Posteingang (Navigation), animiert beim Überfahren */
export function IcPosteingang(p: IconProps) {
  return <svg {...huelle('posteingang', p)}><g className="brief"><rect x="8.5" y="1" width="7" height="5" rx="1"/><path d="M9 1.6l3 2.2 3-2.2"/></g><g className="schale"><path d="M3 13l2.6-7.6A2 2 0 0 1 7.5 4h9a2 2 0 0 1 1.9 1.4L21 13v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><path d="M3 13h5l1.5 2.5h5L16 13h5"/></g></svg>;
}

/** Tickets (Navigation) */
export function IcTickets(p: IconProps) {
  return <svg {...huelle('tickets', p)}><path d="M4 6h16a1 1 0 0 1 1 1v3a2 2 0 0 0 0 4v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-3a2 2 0 0 0 0-4V7a1 1 0 0 1 1-1z"/><path d="M14.5 6.5v2M14.5 11v2M14.5 15.5v2"/></svg>;
}

/** Angebote (Navigation) */
export function IcAngebote(p: IconProps) {
  return <svg {...huelle('angebote', p)}><path d="M6 3h8l4 4v14H6z"/><path d="M14 3v4h4"/><path d="M9 12h6M9 15h6M9 18h3"/></svg>;
}

/** Aufträge (Navigation), animiert beim Überfahren */
export function IcAuftraege(p: IconProps) {
  return <svg {...huelle('auftraege', p)}><g className="brett"><rect x="5" y="4" width="14" height="17" rx="2"/><rect className="klemme" x="9" y="2.5" width="6" height="3" rx="1"/></g><path className="haken" d="M9 13l2 2 4-4"/></svg>;
}

/** Rechnungen (Navigation), animiert beim Überfahren */
export function IcRechnungen(p: IconProps) {
  return <svg {...huelle('rechnungen', p)}><path className="bon" d="M6 3h12v18l-2-1.4-2 1.4-2-1.4-2 1.4-2-1.4L6 21z"/><path className="z z1" d="M9 8h6"/><path className="z z2" d="M9 12h6"/><path className="z z3" d="M9 16h3"/></svg>;
}

/** Artikel (Navigation), animiert beim Überfahren */
export function IcArtikel(p: IconProps) {
  return <svg {...huelle('artikel', p)}><path d="M20 7.5v9L12 21l-8-4.5v-9"/><path d="M4 7.5l8 4.5 8-4.5M12 12v9"/><path className="deckel" d="M4 7.5L12 3l8 4.5L12 12z"/></svg>;
}

/** Lager (Navigation) */
export function IcLager(p: IconProps) {
  return <svg {...huelle('lager', p)}><path d="M3 21V9l9-5 9 5v12"/><path d="M7 21v-7h10v7M7 17.5h10"/></svg>;
}

/** Einkauf (Navigation) */
export function IcEinkauf(p: IconProps) {
  return <svg {...huelle('einkauf', p)}><circle cx="9" cy="20" r="1.3"/><circle cx="17" cy="20" r="1.3"/><path d="M3 4h2l2.4 11h11l2-8H6.2"/></svg>;
}

/** Lieferanten (Navigation), animiert beim Überfahren */
export function IcLieferanten(p: IconProps) {
  return <svg {...huelle('lieferanten', p)}><path d="M3 21V11l5 3v-3l5 3V6h4l1 3h3v12z"/><path className="fenster" d="M7 17.5h2M11.5 17.5h2M16 17.5h2"/><circle className="rauch r1" cx="15" cy="3.6" r="1"/><circle className="rauch r2" cx="16.8" cy="1.8" r="0.8"/></svg>;
}

/** Sendungen (Navigation) */
export function IcSendungen(p: IconProps) {
  return <svg {...huelle('sendungen', p)}><path d="M2.5 6.5h10.5v9.5H2.5z"/><path d="M13 9.5h4l3.5 3.5V16H13"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="16.5" cy="17.5" r="1.8"/></svg>;
}

/** Auswertungen (Navigation), animiert beim Überfahren */
export function IcAuswertungen(p: IconProps) {
  return <svg {...huelle('auswertungen', p)}><path className="kreis" d="M12 3a9 9 0 1 0 9 9h-9z"/><path className="segment" d="M15 3.5A9 9 0 0 1 20.5 9H15z"/></svg>;
}

/** Wiki (Navigation), animiert beim Überfahren */
export function IcWiki(p: IconProps) {
  return <svg {...huelle('wiki', p)}><path d="M4 19V5a2 2 0 0 1 2-2h13v14H6a2 2 0 0 0-2 2a2 2 0 0 0 2 2h13v-4"/><path className="zeile" d="M9 7h6"/><path className="blatt" d="M6 3h13v14H6z"/></svg>;
}

/** Kalender (Navigation) */
export function IcKalender(p: IconProps) {
  return <svg {...huelle('kalender', p)}><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M3 10h18M8 3v4M16 3v4"/></svg>;
}

/** KI-Assistent (Navigation), animiert beim Überfahren */
export function IcKiAssistent(p: IconProps) {
  return <svg {...huelle('ki-assistent', p)}><path className="stern" d="M11 3l1.7 5.3L18 10l-5.3 1.7L11 17l-1.7-5.3L4 10l5.3-1.7z"/><path className="funke" d="M18.5 15l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z"/></svg>;
}

/** Nachrichten (Navigation) */
export function IcNachrichten(p: IconProps) {
  return <svg {...huelle('nachrichten', p)}><path d="M4 5h16v11H9.5L5 19.5V16H4z"/><path d="M8 9h8M8 12h5"/></svg>;
}

/** Einstellungen (Navigation), animiert beim Überfahren */
export function IcEinstellungen(p: IconProps) {
  return <svg {...huelle('einstellungen', p)}><path className="spur s1l" d="M4 7h9"/><path className="spur s1r" d="M18 7h2"/><path className="spur s2l" d="M4 17h3"/><path className="spur s2r" d="M12 17h8"/><circle className="regler g1" cx="15.5" cy="7" r="2.3"/><circle className="regler g2" cx="9.5" cy="17" r="2.3"/></svg>;
}

/** Rollen und Rechte (Navigation) */
export function IcRollen(p: IconProps) {
  return <svg {...huelle('rollen', p)}><path d="M12 3l8 3v6c0 4.5-3.4 8-8 9-4.6-1-8-4.5-8-9V6z"/><path d="M9 12l2 2 4-4"/></svg>;
}

/** Kopfdaten (Belegbereiche) */
export function IcKopfdaten(p: IconProps) {
  return <svg {...huelle('kopfdaten', p)}><rect x="3" y="5" width="18" height="14" rx="2"/><circle cx="8.5" cy="10.5" r="2"/><path d="M5.8 16c.6-1.4 1.6-2 2.7-2s2.1.6 2.7 2M14 10h4M14 13.5h4"/></svg>;
}

/** Positionen (Belegbereiche) */
export function IcPositionen(p: IconProps) {
  return <svg {...huelle('positionen', p)}><path d="M9 6h11M9 12h11M9 18h11"/><circle cx="4.5" cy="6" r="1"/><circle cx="4.5" cy="12" r="1"/><circle cx="4.5" cy="18" r="1"/></svg>;
}

/** Rabatt (Belegbereiche) */
export function IcRabatt(p: IconProps) {
  return <svg {...huelle('rabatt', p)}><path d="M18 6L6 18"/><circle cx="7.5" cy="7.5" r="2.3"/><circle cx="16.5" cy="16.5" r="2.3"/></svg>;
}

/** Steuer und Summen (Belegbereiche) */
export function IcSteuer(p: IconProps) {
  return <svg {...huelle('steuer', p)}><rect x="5" y="3" width="14" height="18" rx="2"/><path d="M8.5 6.5h7v3h-7z"/><path d="M8.5 13.5h.01M12 13.5h.01M15.5 13.5h.01M8.5 17h.01M12 17h.01M15.5 17h.01"/></svg>;
}

/** Zahlungsbedingungen (Belegbereiche), animiert beim Überfahren */
export function IcZahlungsziel(p: IconProps) {
  return <svg {...huelle('zahlungsziel', p)}><circle className="ziffer" cx="12" cy="12" r="9"/><path className="zeiger zeiger-m" d="M12 12V7"/><path className="zeiger zeiger-h" d="M12 12l3.2 2"/></svg>;
}

/** Anhänge (Belegbereiche) */
export function IcAnhang(p: IconProps) {
  return <svg {...huelle('anhang', p)}><path d="M20 11.5l-8.2 8.2a5 5 0 0 1-7-7L13.2 4.3a3.4 3.4 0 0 1 4.8 4.8l-8.3 8.3a1.8 1.8 0 0 1-2.6-2.6l7.6-7.6"/></svg>;
}

/** Notizen (Belegbereiche) */
export function IcNotiz(p: IconProps) {
  return <svg {...huelle('notiz', p)}><path d="M5 4h14v11l-5 5H5z"/><path d="M14 20v-5h5M8.5 9h7M8.5 12h4"/></svg>;
}

/** Unterschrift (Belegbereiche) */
export function IcUnterschrift(p: IconProps) {
  return <svg {...huelle('unterschrift', p)}><path d="M3 16c2-3.6 3.8-8 5.6-8 2.2 0-.7 8 1.6 8 1.4 0 2.3-2.6 3.7-2.6 1.1 0 1 1.8 2.4 1.8.8 0 1.5-.5 2.1-1"/><path d="M3 20.5h18"/></svg>;
}

/** E-Rechnung (Belegbereiche) */
export function IcERechnung(p: IconProps) {
  return <svg {...huelle('e-rechnung', p)}><path d="M6 3h8l4 4v14H6z"/><path d="M14 3v4h4"/><path d="M10.2 12.5l-1.8 2 1.8 2M13.8 12.5l1.8 2-1.8 2"/></svg>;
}

/** DATEV-Export (Belegbereiche) */
export function IcExport(p: IconProps) {
  return <svg {...huelle('export', p)}><path d="M12 15V3.5M7.5 8L12 3.5 16.5 8"/><path d="M4 14v4.5A2.5 2.5 0 0 0 6.5 21h11a2.5 2.5 0 0 0 2.5-2.5V14"/></svg>;
}

/** Mahnung (Belegbereiche) */
export function IcMahnung(p: IconProps) {
  return <svg {...huelle('mahnung', p)}><path d="M6 3h8l4 4v14H6z"/><path d="M14 3v4h4"/><path d="M12 11v3.5M12 17.5h.01"/></svg>;
}

/** Zahlungseingang (Belegbereiche), animiert beim Überfahren */
export function IcZahlungseingang(p: IconProps) {
  return <svg {...huelle('zahlungseingang', p)}><path className="dach" d="M3 9l9-5 9 5"/><path className="saeule s1" d="M5.5 10v8"/><path className="saeule s2" d="M10 10v8"/><path className="saeule s3" d="M14 10v8"/><path className="saeule s4" d="M18.5 10v8"/><path d="M3 21h18"/></svg>;
}

/** Betrag (Belegbereiche) */
export function IcWaehrung(p: IconProps) {
  return <svg {...huelle('waehrung', p)}><path d="M17.5 6.5a7 7 0 1 0 0 11"/><path d="M4 10.5h9M4 13.5h9"/></svg>;
}

/** Entwurf (Status) */
export function IcEntwurf(p: IconProps) {
  return <svg {...huelle('entwurf', p)}><path d="M4 20h4L19 9l-4-4L4 16z"/><path d="M13.5 6.5l4 4"/></svg>;
}

/** Gesendet (Status) */
export function IcGesendet(p: IconProps) {
  return <svg {...huelle('gesendet', p)}><path d="M21 3L10 14"/><path d="M21 3l-6.5 18-4.5-7-7-4.5z"/></svg>;
}

/** Angenommen (Status) */
export function IcAngenommen(p: IconProps) {
  return <svg {...huelle('angenommen', p)}><circle cx="12" cy="12" r="9"/><path d="M8 12.5l2.7 2.7L16 9.6"/></svg>;
}

/** Abgelehnt (Status) */
export function IcAbgelehnt(p: IconProps) {
  return <svg {...huelle('abgelehnt', p)}><circle cx="12" cy="12" r="9"/><path d="M9 9l6 6M15 9l-6 6"/></svg>;
}

/** Bezahlt (Status) */
export function IcBezahlt(p: IconProps) {
  return <svg {...huelle('bezahlt', p)}><rect x="2.5" y="6" width="19" height="12" rx="2"/><circle cx="12" cy="12" r="2.6"/><path d="M6 9.5h.01M18 14.5h.01"/></svg>;
}

/** Überfällig (Status) */
export function IcUeberfaellig(p: IconProps) {
  return <svg {...huelle('ueberfaellig', p)}><circle cx="12" cy="13" r="8"/><path d="M12 9v4.2M12 16.6h.01M9.5 2.5h5"/></svg>;
}

/** In Bearbeitung (Status) */
export function IcInBearbeitung(p: IconProps) {
  return <svg {...huelle('in-bearbeitung', p)}><path d="M12 3a9 9 0 1 1-9 9"/><path d="M12 7.5V12l2.5 1.5"/></svg>;
}

/** Liniendiagramm (Diagramme) */
export function IcDiagrammLinie(p: IconProps) {
  return <svg {...huelle('diagramm-linie', p)}><path d="M3 20.5h18"/><path d="M4 15.5l4.5-5 4 3L20 6"/></svg>;
}

/** Balkendiagramm (Diagramme) */
export function IcDiagrammBalken(p: IconProps) {
  return <svg {...huelle('diagramm-balken', p)}><path d="M3 20.5h18"/><rect x="5" y="12" width="3.5" height="8.5" rx="1"/><rect x="10.25" y="6" width="3.5" height="14.5" rx="1"/><rect x="15.5" y="9" width="3.5" height="11.5" rx="1"/></svg>;
}

/** Ringdiagramm (Diagramme) */
export function IcDiagrammRing(p: IconProps) {
  return <svg {...huelle('diagramm-ring', p)}><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3.5"/><path d="M12 4v4.5M19.6 14.4l-4.3-1.3"/></svg>;
}

/** Trend steigend (Diagramme) */
export function IcTrendHoch(p: IconProps) {
  return <svg {...huelle('trend-hoch', p)}><path d="M3 17l6-6 4 4 7.5-7.5"/><path d="M15 7.5h5.5V13"/></svg>;
}

/** Trend fallend (Diagramme) */
export function IcTrendRunter(p: IconProps) {
  return <svg {...huelle('trend-runter', p)}><path d="M3 7l6 6 4-4 7.5 7.5"/><path d="M15 16.5h5.5V11"/></svg>;
}

/** Tabellenansicht (Diagramme) */
export function IcTabelle(p: IconProps) {
  return <svg {...huelle('tabelle', p)}><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 9.5h18M3 14.5h18M9 9.5V20"/></svg>;
}

/** Verpackt (Sendung) */
export function IcVerpackt(p: IconProps) {
  return <svg {...huelle('verpackt', p)}><path d="M4 8l8-4 8 4v8.5L12 20.5 4 16.5z"/><path d="M4 8l8 4 8-4M12 12v8.5M8 6l8 4"/></svg>;
}

/** Abgeholt (Sendung) */
export function IcAbholung(p: IconProps) {
  return <svg {...huelle('abholung', p)}><path d="M3 13h4l3 2h4.5a1.5 1.5 0 0 1 0 3H10"/><path d="M14.5 18l5-2.2a1.6 1.6 0 0 1 1.5 2.8L14 21.5H3"/><rect x="10" y="3" width="8" height="7" rx="1"/><path d="M14 3v3"/></svg>;
}

/** Seefracht (Sendung), animiert beim Überfahren */
export function IcSeefracht(p: IconProps) {
  return <svg {...huelle('seefracht', p)}><g className="schiff"><path d="M3 14.5h18l-2.2 5.5H5.2z"/><path d="M6 14.5V10h12v4.5M12 10V5"/><path className="flagge" d="M12 5h4"/></g><path className="welle" d="M-4 22.6c1.5 0 1.5-1 3-1s1.5 1 3 1 1.5-1 3-1 1.5 1 3 1 1.5-1 3-1 1.5 1 3 1 1.5-1 3-1 1.5 1 3 1 1.5-1 3-1 1.5 1 3 1"/></svg>;
}

/** Zoll (Sendung) */
export function IcZoll(p: IconProps) {
  return <svg {...huelle('zoll', p)}><path d="M9 13.5V10a3 3 0 1 1 6 0v3.5"/><path d="M5.5 13.5h13v4h-13zM5 21h14"/></svg>;
}

/** Zugestellt (Sendung) */
export function IcZugestellt(p: IconProps) {
  return <svg {...huelle('zugestellt', p)}><path d="M3.5 11l8.5-7 8.5 7v9a1 1 0 0 1-1 1h-15a1 1 0 0 1-1-1z"/><path d="M9 15l2 2 4-4.2"/></svg>;
}

/** Standort (Sendung) */
export function IcStandort(p: IconProps) {
  return <svg {...huelle('standort', p)}><path d="M12 21s-7-6.2-7-11a7 7 0 0 1 14 0c0 4.8-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/></svg>;
}

/** Neu (Aktionen) */
export function IcPlus(p: IconProps) {
  return <svg {...huelle('plus', p)}><path d="M12 5v14M5 12h14"/></svg>;
}

/** Suche (Aktionen) */
export function IcSuche(p: IconProps) {
  return <svg {...huelle('suche', p)}><circle cx="11" cy="11" r="6.5"/><path d="M20 20l-4.3-4.3"/></svg>;
}

/** Filter (Aktionen) */
export function IcFilter(p: IconProps) {
  return <svg {...huelle('filter', p)}><path d="M4 5h16l-6 7.5V19l-4 1.5v-8z"/></svg>;
}

/** Herunterladen (Aktionen) */
export function IcDownload(p: IconProps) {
  return <svg {...huelle('download', p)}><path d="M12 3.5V15M7.5 10.5L12 15l4.5-4.5"/><path d="M4 16.5v2A2.5 2.5 0 0 0 6.5 21h11a2.5 2.5 0 0 0 2.5-2.5v-2"/></svg>;
}

/** E-Mail (Aktionen) */
export function IcMail(p: IconProps) {
  return <svg {...huelle('mail', p)}><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3.5 6.5l8.5 6.5 8.5-6.5"/></svg>;
}

/** Benachrichtigungen (Aktionen) */
export function IcGlocke(p: IconProps) {
  return <svg {...huelle('glocke', p)}><path d="M6 16v-5a6 6 0 0 1 12 0v5l1.5 2h-15z"/><path d="M10 21h4"/></svg>;
}

/** Weiter (Aktionen) */
export function IcPfeilRechts(p: IconProps) {
  return <svg {...huelle('pfeil-rechts', p)}><path d="M5 12h14M13 6l6 6-6 6"/></svg>;
}

/** Schließen (Aktionen) */
export function IcSchliessen(p: IconProps) {
  return <svg {...huelle('schliessen', p)}><path d="M6 6l12 12M18 6L6 18"/></svg>;
}

/** Mehr (Aktionen) */
export function IcMehr(p: IconProps) {
  return <svg {...huelle('mehr', p)}><circle cx="5.5" cy="12" r="1.1"/><circle cx="12" cy="12" r="1.1"/><circle cx="18.5" cy="12" r="1.1"/></svg>;
}

/** Löschen (Aktionen) */
export function IcLoeschen(p: IconProps) {
  return <svg {...huelle('loeschen', p)}><path d="M4 7h16M10 3.5h4M6.5 7l.9 12.2A2 2 0 0 0 9.4 21h5.2a2 2 0 0 0 2-1.8L17.5 7"/><path d="M10 11v6M14 11v6"/></svg>;
}

/** Debitoren (Forderungen, Geld kommt herein) (Navigation), animiert beim Überfahren */
export function IcDebitoren(p: IconProps) {
  return <svg {...huelle('debitoren', p)}><g className="beleg"><path d="M13 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h5"/><path d="M13 3l5 5v3"/><path d="M13 3v5h5"/></g><path className="z z1" d="M8 12h4"/><path className="z z2" d="M8 16h2"/><g className="pfeil pfeil-ein"><path d="M21 21l-6-6"/><path d="M15 19.5V15h4.5"/></g></svg>;
}

/** Kreditoren (Verbindlichkeiten, Geld geht hinaus) (Navigation), animiert beim Überfahren */
export function IcKreditoren(p: IconProps) {
  return <svg {...huelle('kreditoren', p)}><g className="beleg"><path d="M13 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h5"/><path d="M13 3l5 5v3"/><path d="M13 3v5h5"/></g><path className="z z1" d="M8 12h4"/><path className="z z2" d="M8 16h2"/><g className="pfeil pfeil-aus"><path d="M15 15l6 6"/><path d="M21 16.5V21h-4.5"/></g></svg>;
}

/** Alle Icons nach Schlüssel, z. B. für Musterseiten */
export const ICONS = {
  'dashboard': IcDashboard,
  'kunden': IcKunden,
  'posteingang': IcPosteingang,
  'tickets': IcTickets,
  'angebote': IcAngebote,
  'auftraege': IcAuftraege,
  'rechnungen': IcRechnungen,
  'artikel': IcArtikel,
  'lager': IcLager,
  'einkauf': IcEinkauf,
  'lieferanten': IcLieferanten,
  'sendungen': IcSendungen,
  'auswertungen': IcAuswertungen,
  'wiki': IcWiki,
  'kalender': IcKalender,
  'ki-assistent': IcKiAssistent,
  'nachrichten': IcNachrichten,
  'einstellungen': IcEinstellungen,
  'rollen': IcRollen,
  'kopfdaten': IcKopfdaten,
  'positionen': IcPositionen,
  'rabatt': IcRabatt,
  'steuer': IcSteuer,
  'zahlungsziel': IcZahlungsziel,
  'anhang': IcAnhang,
  'notiz': IcNotiz,
  'unterschrift': IcUnterschrift,
  'e-rechnung': IcERechnung,
  'export': IcExport,
  'mahnung': IcMahnung,
  'zahlungseingang': IcZahlungseingang,
  'waehrung': IcWaehrung,
  'entwurf': IcEntwurf,
  'gesendet': IcGesendet,
  'angenommen': IcAngenommen,
  'abgelehnt': IcAbgelehnt,
  'bezahlt': IcBezahlt,
  'ueberfaellig': IcUeberfaellig,
  'in-bearbeitung': IcInBearbeitung,
  'diagramm-linie': IcDiagrammLinie,
  'diagramm-balken': IcDiagrammBalken,
  'diagramm-ring': IcDiagrammRing,
  'trend-hoch': IcTrendHoch,
  'trend-runter': IcTrendRunter,
  'tabelle': IcTabelle,
  'verpackt': IcVerpackt,
  'abholung': IcAbholung,
  'seefracht': IcSeefracht,
  'zoll': IcZoll,
  'zugestellt': IcZugestellt,
  'standort': IcStandort,
  'plus': IcPlus,
  'suche': IcSuche,
  'filter': IcFilter,
  'download': IcDownload,
  'mail': IcMail,
  'glocke': IcGlocke,
  'pfeil-rechts': IcPfeilRechts,
  'schliessen': IcSchliessen,
  'mehr': IcMehr,
  'loeschen': IcLoeschen,
  'debitoren': IcDebitoren,
  'kreditoren': IcKreditoren,
} as const;
export type IconName = keyof typeof ICONS;
